import { apiClient } from "./api";

// Track whether the backend has responded at least once in this browser tab.
// If it has, subsequent requests are unlikely to hit a cold-start.
let warm = false;
let inflight = null;

/**
 * Fire-and-forget ping to warm up the backend pod.
 * Safe to call repeatedly — resolves instantly if already warm and dedupes concurrent calls.
 */
export const pingBackend = () => {
  if (warm) return Promise.resolve(true);
  if (inflight) return inflight;
  inflight = apiClient
    .get("/health", { timeout: 30000 })
    .then(() => {
      warm = true;
      return true;
    })
    .catch(() => false)
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

export const isBackendWarm = () => warm;

// Called after any successful auth/data request so the login page can skip
// showing the "waking up" overlay on subsequent submits.
export const markBackendWarm = () => {
  warm = true;
};
